import { render, staticRenderFns } from "./goodsSaleStat.vue?vue&type=template&id=dcd25e08&"
import script from "./goodsSaleStat.vue?vue&type=script&lang=js&"
export * from "./goodsSaleStat.vue?vue&type=script&lang=js&"
import style0 from "./goodsSaleStat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports